import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
import { Model, Inputs, lackingPromiseOrWasmSupport } from './model';
export function loadOnnx(scriptSrc, buildName) {
    // Create log operation
    const createInferenceServiceOp = new LogOperation({
        operationName: 'CreateOnnxInferenceService',
        success: true,
        resultDescription: ''
    });
    createInferenceServiceOp.start();
    // Ensure browser has proper support
    if (lackingPromiseOrWasmSupport(createInferenceServiceOp)) {
        const errMsg = 'Browser lacks necessary support for inference service';
        createInferenceServiceOp.success = false;
        createInferenceServiceOp.resultDescription = errMsg;
        Log.info(0x2035f413 /* tag_6n5qt */, LogCategory.CoreDefault, createInferenceServiceOp.stop());
        return Promise.reject(new Error(errMsg));
    }
    // Load ONNX
    return new Promise((resolve, reject) => {
        if (typeof (document) !== 'undefined') {
            // Logic when executed on the main thread
            const script = document.createElement('script');
            script.src = scriptSrc;
            script.onload = () => {
                if (isOnnxSetGlobally(buildName)) {
                    resolve();
                }
                else {
                    script.remove();
                    reject(new Error('ort.Tensor and/or ort.InferenceSession are undefined'));
                }
            };
            script.onerror = reject;
            document.body.appendChild(script);
        }
        else if (globalThis.importScripts) {
            // Logic when executed in Web Worker
            globalThis.importScripts(scriptSrc);
            globalThis[buildName] = self[buildName];
            // Web Worker will not have 'gloablThis.top' to begin
            if (!globalThis.top) {
                globalThis.top = {};
            }
            if (isOnnxSetGlobally(buildName)) {
                resolve();
            }
            else {
                reject(new Error('ort.Tensor and/or ort.InferenceSession are undefined'));
            }
        }
        else {
            reject(new Error('Unexpected lack of document and importScripts'));
        }
    }).then(() => {
        Log.info(0x2035f414 /* tag_6n5qu */, LogCategory.CoreDefault, createInferenceServiceOp.stop());
    }).catch((err) => {
        createInferenceServiceOp.success = false;
        createInferenceServiceOp.resultDescription = err.message;
        Log.info(0x1e6406db /* tag_4za11 */, LogCategory.CoreDefault, createInferenceServiceOp.stop());
        throw err; // Want to log error, but also want it to go back to onnxInferenceService / workflow
    });
}
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function createModel(modelUrl, modelName, onnxObject) {
    return Model.create(modelUrl, modelName, onnxObject);
}
export function createInputs() {
    return Inputs.create();
}
function isOnnxSetGlobally(buildName) {
    const aiBuild = globalThis[buildName];
    if (aiBuild && aiBuild.InferenceSession && aiBuild.Tensor) {
        if ((globalThis === null || globalThis === void 0 ? void 0 : globalThis.top) && !globalThis.top[buildName]) {
            globalThis.top[buildName] = aiBuild;
        }
        return true;
    }
    else {
        return false; // build does not contain proper information
    }
}
//# sourceMappingURL=onnxInferenceServiceBasicMethods.js.map